import React from 'react'


export default function ObjectResponse( props ) {
    const _message = props?.conversation
    console.log(props)
    return (
        <div style={{ background:"#dee0e3", borderRadius:"10px", margin:"0px 10px 0px 10px", display:"flex", gap:"5px"}}>
            <div style={{width:"8px", background:"#06cf9c",  borderTopLeftRadius:"10px", borderBottomLeftRadius:"10px"}}>&nbsp;</div>
            <div style={{padding:"10px", display:"flex", justifyContent:"space-between", width:"100%"}}>
                <div style={{width:"100%"}}>
                    <span style={{fontWeight:"bold", color:"#06cf9c"}}>{_message?.username}</span>
                    {_message?.type === 'chat' && (
                        <div>
                            <span style={{flexWrap:"wrap"}}>{_message?.body}</span>
                        </div>
                    )}
                     {['video','image','sticker'].includes(_message?.type) && (
                        <>
                            <div>
                                <span style={{flexWrap:"wrap"}}>{_message?.body}</span>                            
                            </div>
                            <div style={{display:"flex",justifyContent:"flex-end"}}>
                                <img src={'data:image/jpg;base64,' + _message.file} alt="" style={{borderRadius:"5px",maxWidth:"100px"}}/>
                            </div>
                        </>
                    )}
                     {['ptt','audio/ogg; codecs=opus','audio'].includes(_message?.type) && (
                        <div>
                            <i className='fa fa-microphone' style={{color:"#4fc3f7"}}/>
                        </div>
                     )}
                     {['document'].includes(_message?.type) && (
                        <>
                            <div>
                                <span style={{flexWrap:"wrap"}}>{_message?.body}</span>                            
                            </div>
                            <div style={{display:"flex",justifyContent:"flex-end", margin:"-15px 15px 0px 0px"}}>
                                <i className='fa fa-file' style={{fontSize:"58px",color:"#4fc3f7"}}/>
                            </div>
                        </>
                        
                     )}
                     {['vcard'].includes(_message?.type) && (
                        <>
                            <div>
                                <span style={{flexWrap:"wrap"}}>{_message?.body}</span>                            
                            </div>
                            <div style={{display:"flex",justifyContent:"flex-end", margin:"-15px 15px 0px 0px"}}>
                                <i className='fa fa-address-card' style={{fontSize:"58px",color:"#4fc3f7"}}/>
                            </div>
                        </>
                        
                     )}
                     {['location'].includes(_message?.type) && (
                        <>
                            <div style={{display:"flex",justifyContent:"flex-end", margin:"-15px 15px 0px 0px"}}>
                                <i className='fa fa-map-location-dot' style={{fontSize:"58px",color:"#4fc3f7"}}/>
                            </div>
                        </>
                        
                     )}
                </div>
                {!props?.hiddenClose && (
                    <div style={{display:"flex",alignItems:'center', height:"100%", cursor:"pointer"}} onClick={e => props?.onClose()}>
                        <i className='fa fa-xmark' style={{fontSize:"18px"}}/>
                    </div>
                )}
            </div>
    </div>
    )
}